import { callBackendApi } from "../axiosInstances/backendInstance/apiRequest";

export async function getAllBlogPosts() {
    return await callBackendApi('/blog', 'GET');
}

export async function getBlogPostById(id) {
    return await callBackendApi('blog/' + id, 'GET');
}